/**
 * useDebugContact - Who a captured leg was with
 *
 * A record stores the phone number, not the person. Both the history row and
 * the record header need the resolved contact, and neither should own the
 * store lookup.
 */

import { MobXProviderContext } from 'mobx-react';
import { resolveContactInfo } from 'Modules/softphone/resolver/contactResolver';
import { useContext } from 'react';
import type { RootStoreProps } from 'Stores/RootStore.types';

export interface DebugContact {
  displayName: string;
  phoneNumber: string;
  avatarUrl?: string;
}

export const useDebugContact = (phoneNumber: string): DebugContact => {
  const { person: personStore } = useContext(
    MobXProviderContext
  ) as RootStoreProps;

  const contact = resolveContactInfo(personStore, phoneNumber, undefined);

  return {
    displayName: contact.displayName || phoneNumber,
    phoneNumber: contact.phoneNumber || phoneNumber,
    avatarUrl: contact.avatarUrl,
  };
};
